<template>
	<el-select v-model="select" collapse-tags clearable :multiple="type=='selects'" filterable :placeholder="placeholder" :size="$store.state.isphone?'mini':''" @change="change()" style="width: 100%;">
		<el-option v-for="(items,key) in selectdata" :label="items[prop.label]" :value="items[prop.value]" :key="key"></el-option>
	</el-select>
</template>

<script>
	export default {
		data() {
			return {
				selectdata: []
			}
		},
		methods:{
			getdata()
			{
				if(this.data instanceof Array)
				{
					this.selectdata=this.data;
				}
				else if((typeof this.data)=='function')
				{
					this.data(this);
				}
			}
		},
		props: {
			value: {
				type: [String,Number],
				default: ''
			},
			placeholder: {
				type: String,
				default: ''
			},
			type: {
				type: String,
				default: 'select'
			},
			data: {
				type: [Array,Function],
				default: function () {
					return [];
				}
			},
			prop: {
				type: Object,
				default: function () {
					return {
						label: 'name',
						value: 'id'
					};
				}
			},
			change: {
				type: Function,
				default: function () {
					
				}
			},
			show: {
				type: Boolean,
				default: false
			}
		},
		mounted: function () {
			this.getdata();
		},
		computed:{
			select: {
				get () {
					if(this.type=='select')
					{
						return this.value;
					}
					else
					{
						if(this.value=='')
						{
							return []
						}
						else
						{
							return this.value.split(',').map((v)=>{
								if(this.selectdata.length>0)
								{
									return ((typeof this.selectdata[0][this.prop.value])=="number"?Number(v):v);
								}
							});
						}
					}
				},
				set (value) {
					if(this.type=='select')
					{
						var o=document.createElement('input');
						o.input=()=>{
							this.$emit('input', value);
						}
						o.input();
					}
					else
					{
						var o=document.createElement('input');
						o.input=()=>{
							this.$emit('input', this.adrtrans(value).toString());
						}
						o.input();
					}
				}
			}
		},
		watch: {
			show(newval,oldval){
				if(newval)
				{
					this.getdata();
				}
			}
		}
	}
</script>

<style>
</style>
